export default {
  MEMBER_GET_MEMBER_FETCHED: 'MEMBER_GET_MEMBER_FETCHED',
  MEMBER_GET_MEMBER_LOAD: 'MEMBER_GET_MEMBER_LOAD',
  MEMBER_GET_MEMBER_TEMPLATES_FETCHED: 'MEMBER_GET_MEMBER_TEMPLATES_FETCHED',
  MEMBER_GET_MEMBER_TEMPLATES_LOAD: 'MEMBER_GET_MEMBER_TEMPLATES_LOAD',
  MEMBER_GET_MEMBER_DETAIL: 'MEMBER_GET_MEMBER_DETAIL',
  MEMBER_GET_MEMBER_BUTTON_LOAD: 'MEMBER_GET_MEMBER_BUTTON_LOAD',
};
